import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/CloseTabs.svg?component
var CloseTabs_exports = /* @__PURE__ */ __exportAll({
	default: () => CloseTabs_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2m-3.121 8.879 4.242 4.242m0-4.242L12.88 17.12M10 8h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2"
	}, null, -1)])]);
}
var CloseTabs_default = { render: render$1 };
//#endregion
export { CloseTabs_exports, CloseTabs_default as default, render$1 as render };

//# sourceMappingURL=CloseTabs.svg_component.js.map